import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  subTitle: {
    wordBreak: 'break-word',
  },
}));

export interface HeadingSectionProps {
  title: string;
  subtitle?: string | JSX.Element;
  overTitle?: string | JSX.Element;
}

export default function HeadingSection(props: HeadingSectionProps) {
  const { title, subtitle, overTitle } = props;
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mb={3}
      mt={6}
      className="main-heading-section"
    >
      {overTitle && (
        <Typography component="h2" variant="h4">
          {overTitle}
        </Typography>
      )}
      <Typography component="h1" variant="h1">
        {title}
      </Typography>
      {subtitle && (
        <Typography component="h2" variant="h4" className={classes.subTitle}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
